export default "__VITE_ASSET__CzqpNNVR__"